/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2024, 2025
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([], () => {
	return {
		VALUE_TYPE: {
			LABEL: 'label',
			VALUE: 'value'
		},
		DEFAULT_ROW_HEIGHT: 32,
		MIN_COLUMN_WIDTH: 100,
		SUMMARY_COLS_THRESHOLD: 12,
		ROW_HEADER_INDEX: 0,
		TABINDEX: 0,
		IS_SUMMARY: 'isSummary'
	};

});
